import styled from 'styled-components';

export const StyledBroadsiderHudPopup = styled.div`
  z-index: ${({ $zindex }) => $zindex};
  position: absolute;
  top: ${({ theme }) => theme.navHeight};
  right: ${({ theme, $right }) => $right};
  width: ${({ $width }) => $width};
  min-width: ${({ $minWidth }) => $minWidth};
  height: ${({ theme, $bottomOffset }) => 'calc(100vh - ' + theme.frameOffset + ' - ' + theme.navHeight + ' - ' + $bottomOffset + ')'};
  transform: translateX(${({ $collapsed, theme }) => $collapsed ? '100vw' : '0'}));
  margin: ${({ theme }) => 'unset'};
  transition: transform .2s linear;

  .broadsider-hud-modal-content {
    animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;
    --local-scale: ${({ theme, $disableScaling }) => $disableScaling ? 1 : 'max('+theme.minModalScale+', var(--app-scale))'};
    
    height: calc(100% / var(--local-scale) );
    transform: scale(var(--local-scale));
    transform-origin: 50% 0;
    position: relative;

    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    -webkit-backdrop-filter: blur(10px);
    -moz-backdrop-filter: blur(10px);
    -ms-backdrop-filter: blur(10px);
    -o-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  .broadsider-hud-modal-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .broadsider-hud-modal-corner-tl {
    border-right: none;
    border-bottom: none;
    top: ${({ theme }) => '-' + theme.frameWidth};
    left: ${({ theme }) => '-' + theme.frameWidth};
  }

  .broadsider-hud-modal-corner-tr {
    border-left: none;
    border-bottom: none;
    top: ${({ theme }) => '-' + theme.frameWidth};
    right: ${({ theme }) => '-' + theme.frameWidth};
  }

  .broadsider-hud-modal-corner-br {
    border-left: none;
    border-top: none;
    bottom: ${({ theme }) => '-' + theme.frameWidth};
    right: ${({ theme }) => '-' + theme.frameWidth};
  }

  .broadsider-hud-modal-corner-bl {
    border-right: none;
    border-top: none;
    bottom: ${({ theme }) => '-' + theme.frameWidth};
    left: ${({ theme }) => '-' + theme.frameWidth};
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    position: unset;
    width: 100%;
    height: 100%;
  }
`;
